import { useRef, useState } from "react";

import { parseValue } from "../../../../../../ui library/helpers/functions";
import { FieldsOrderedList } from "../helpers/fieldOrderConfig";

import { FieldModule } from "./FieldModule";

export function SchemaComponentForm({
  schema,
  placeholder,
  staticOptionsByField,
  data,
  commitOnBlurOnly = false,
  onCommit,
  additionalReq,
}) {
  const { properties } = schema;
  const [form, setForm] = useState(data || {});
  const [err, setErr] = useState({});

  const fields = Object.keys(properties || {}).filter((name) => name !== "id");
  const orderedFields = FieldsOrderedList.filter((key) => fields.includes(key));

  const onChange = (field, value) => {
    const fieldSchema = properties?.[field];
    const type = fieldSchema?.type;
    const parsedValue = parseValue(value, type);
    const updated = { ...form, [field]: parsedValue };
    setForm(updated);
    setErr((e) => ({ ...e, [field]: undefined }));

    // Commit-on-blur mode: do not notify parent on every keystroke
    if (!commitOnBlurOnly) {
      onCommit(updated);
    }
  };

  const containerRef = useRef(null);
  const skipCommitOnBlurRef = useRef(false);

  const handleContainerBlur = (e) => {
    if (!commitOnBlurOnly) {
      return;
    }
    // Required to skip commit on blur if the next focused element requests it
    const rt = e?.relatedTarget;
    if (rt && rt.getAttribute?.("data-skip-blur-commit") === "true") {
      skipCommitOnBlurRef.current = true;
    }
    // Defer commit to the next task to avoid interfering with select menu clicks
    setTimeout(() => {
      if (skipCommitOnBlurRef.current) {
        skipCommitOnBlurRef.current = false;
        return;
      }
      const active = document.activeElement;
      if (!containerRef.current) {
        return;
      }
      if (!active || !containerRef.current.contains(active)) {
        if (typeof onCommit === "function") {
          onCommit(form);
        }
      }
    }, 0);
  };

  return (
    <div ref={containerRef} className="flex w-full gap-4" onBlur={handleContainerBlur}>
      {orderedFields.map((name) => {
        const prop = properties[name];
        const enumUrl = typeof prop?.enum === "string" ? prop.enum : undefined;
        return (
          <div key={name} className="w-full">
            <FieldModule
              label={prop?.title || ""}
              requiredConditionally={false}
              isRequired={additionalReq ? additionalReq[name]?.isRequired : prop?.required}
              name={name}
              prop={prop}
              form={form}
              value={form[name]}
              onChange={onChange}
              enumUrl={enumUrl}
              placeholder={placeholder}
              staticOptions={enumUrl ? staticOptionsByField?.[name] : undefined}
            />
            {err[name] && <p className="mt-1 text-sm text-red-600">{err[name]}</p>}
          </div>
        );
      })}
    </div>
  );
}
